import Cookies from 'js-cookie';
import {SKZEnvironment, SKZEnvironmentValue} from '@/utils/SKZEnvironment.types';
import {ENVIRONMENT_COOKIE_NAME} from '@/utils/constant';
import {decrypt} from '@/utils/cryptoHelper';
/**
 * Returns the current Skillz environment from a cookie.
 *
 * The environment is set in the `createCsrfMiddleware` on the server
 * and stored in a cookie (`ENVIRONMENT_COOKIE_NAME`).
 *
 * This function reads that cookie on the client side. If it's not found,
 * it defaults to `SKZEnvironment.STAGING`.
 *
 * @returns {SKZEnvironmentValue} The current environment value.
 */
export function getEnvironmentFromCookie(): SKZEnvironmentValue {
  const encryptedValue = Cookies.get(ENVIRONMENT_COOKIE_NAME);
  if (!encryptedValue) {
    return SKZEnvironment.PRODUCTION;
  }
  // Decrypt and decode the environment value
  const decryptEnv = decrypt(encryptedValue);
  return decryptEnv as SKZEnvironmentValue;
}
